import { render, staticRenderFns } from "./user-center-performance.vue?vue&type=template&id=75316399&scoped=true"
import script from "./user-center-performance.vue?vue&type=script&lang=js"
export * from "./user-center-performance.vue?vue&type=script&lang=js"
import style0 from "./user-center-performance.vue?vue&type=style&index=0&id=75316399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75316399",
  null
  
)

export default component.exports